<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :visible.sync="visible"
    :show-close="true"
    :subject="subject"
    :subtitle="subtitle"
    :theme="theme"
    showCancelBtn
    destroy-on-close
    append-to-body
    width="20%"
    @on-confirm="confirmHandler"
  ></tg-dialog>
</template>

<script>
import TgDialog from "@/components/dialog/TgDialog";

export default {
  inheritAttrs: false,
  components: {
    TgDialog,
  },
  data() {
    return {
      visible: false,
    };
  },
  props: {
    blocked: Number,
    username: String,
    isAll: Boolean,
    action: String,
  },
  computed: {
    prefix() {
      let stackIndex = this.isAll ? "[1]" : "[0]";
      return this.$t("enum.stack" + stackIndex);
    },
    subject() {
      return this.username + " " + this.$t("column." + this.action + "_action");
    },
    subtitle() {
      let langKey = "enum.blocked[" + this.blocked + "]";
      return this.prefix + this.$t(langKey);
    },
    theme() {
      return this.blocked ? "warning" : "info";
    },
  },
  methods: {
    confirmHandler() {
      this.$emit(
        "confirm",
        this.action,
        this.blocked,
        this.username,
        this.isAll
      );
    },
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>